import { Node, mergeAttributes } from '@tiptap/core';
import Suggestion from '@tiptap/suggestion';
import { PluginKey } from 'prosemirror-state';
export const MentionPluginKey = new PluginKey('mention');
export const Mention = Node.create({
    name: 'mention',
    addOptions() {
        return {
            HTMLAttributes: {},
            renderLabel({ node }) {
                var _a;
                return `${(_a = node.attrs.label) !== null && _a !== void 0 ? _a : node.attrs.id}`;
            },
            mentions: [],
            suggestion: {
                char: '@',
                pluginKey: MentionPluginKey,
                command: ({ editor, range, props }) => {
                    var _a;
                    // increase range.to by one when the next node is of type "text"
                    // and starts with a space character
                    const { nodeAfter } = editor.view.state.selection.$to;
                    const overrideSpace = (_a = nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.text) === null || _a === void 0 ? void 0 : _a.startsWith(' ');
                    if (overrideSpace) {
                        range.to += 1;
                    }
                    editor
                        .chain()
                        .focus()
                        .insertContentAt(range, [
                        {
                            type: this.name,
                            attrs: props,
                        },
                        {
                            type: 'text',
                            text: ' ',
                        },
                    ])
                        .run();
                },
                allow: ({ editor, range }) => {
                    const $from = editor.state.doc.resolve(range.from);
                    const type = editor.schema.nodes[this.name];
                    const allow = !!$from.parent.type.contentMatch.matchType(type);
                    return allow;
                },
            },
        };
    },
    group: 'inline',
    inline: true,
    selectable: false,
    atom: true,
    addAttributes() {
        return {
            id: {
                default: null,
                rendered: false,
            },
            label: {
                default: null,
                rendered: false,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: `a[data-type="${this.name}"]`,
                getAttrs: dom => {
                    var _a;
                    if (typeof dom === 'string')
                        return {};
                    const element = dom;
                    const id = element.getAttribute('data-id');
                    const innerText = element.innerText.replace(this.options.suggestion.char, '');
                    const mention = (_a = this.options.mentions) === null || _a === void 0 ? void 0 : _a.find(m => m.id === id);
                    return {
                        id,
                        label: (mention === null || mention === void 0 ? void 0 : mention.name) || innerText,
                    };
                },
            },
        ];
    },
    renderHTML({ node, HTMLAttributes }) {
        return [
            'a',
            mergeAttributes({ 'data-type': this.name }, { 'data-id': node.attrs.id }, this.options.HTMLAttributes, HTMLAttributes),
            this.options.renderLabel({
                options: this.options,
                node,
            }),
        ];
    },
    renderText({ node }) {
        return this.options.renderLabel({
            options: this.options,
            node,
        });
    },
    addKeyboardShortcuts() {
        return {
            Backspace: () => this.editor.commands.command(({ tr, state }) => {
                let isMention = false;
                const { selection } = state;
                const { empty, anchor } = selection;
                if (!empty) {
                    return false;
                }
                state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
                    if (node.type.name === this.name) {
                        isMention = true;
                        tr.insertText(this.options.suggestion.char || '', pos, pos + node.nodeSize);
                        return false;
                    }
                });
                return isMention;
            }),
        };
    },
    addProseMirrorPlugins() {
        return [
            Suggestion({
                editor: this.editor,
                ...this.options.suggestion,
            }),
        ];
    },
});
//# sourceMappingURL=index.js.map